import React, { useEffect } from "react";
import { Field, Label, Select } from "@headlessui/react";
import { Section, sections } from "./models/Section";
import { Control, useController } from "react-hook-form";

type SectionSelectProps = {
  label: string;
  control: Control;
  sectionId?: number;
  onChange?: (section: Section) => void;
};

export default function SectionSelect(props: SectionSelectProps) {
  // const [selected, setSelected] = useState<Section | null>(null);

  const { field: sectionNameField } = useController({
    control: props.control,
    name: "section",
    rules: {
      required: "Section value is required",
    },
  });

  const { field: sectionIdField } = useController({
    control: props.control,
    name: "section_id",
    rules: {
      required: "Section is required",
    },
  });

  const handleSectionChange = (section_id: number) => {
    const section = sections.find((section) => section.id === section_id);

    if (section) {
      sectionIdField.onChange(section?.id);
      sectionNameField.onChange(section?.name);

      props.onChange?.(section);
    }
  };

  // sets the selected section if
  // the sectionId prop is passed in
  useEffect(() => {
    if (props.sectionId === undefined) return;

    handleSectionChange(props.sectionId);
  }, [props.sectionId]);

  return (
    <React.Fragment>
      <div>
        <Field>
          <Label className="block text-sm font-medium text-gray-300">
            {props.label}
          </Label>
          <Select
            name={sectionIdField.name}
            ref={sectionIdField.ref}
            onChange={(e) => handleSectionChange(Number(e.target.value))}
            className={
              "w-full cursor-default grid-cols-1 rounded bg-white py-1 pl-3 pr-2 text-left font-normal text-gray-900  focus-visible:outline focus-visible:outline-1 focus-visible:outline-squawk-blue sm:text-sm/6 border-none"
            }
            value={sectionIdField?.value}
          >
            <option> - </option>
            {sections.map((section) => (
              <option value={section.id} key={section.id}>
                {section.name}
              </option>
            ))}
          </Select>
        </Field>
      </div>
    </React.Fragment>
  );
}
